import { Check } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Eyebrow } from "@/components/PageHero";
import { CALENDAR_URL } from "@/lib/site";

const OPTIONS = [
  {
    badge: "One-Time Setup",
    name: "Done-For-You Setup",
    tagline: "We build your entire Meta ads system once, and you own it.",
    feats: [
      "Market & ideal-customer research",
      "Hook testing to find what converts",
      "Conversion video ads, scripted & coached",
      "Full Meta build, pixel & campaign launch",
      "Leads delivered to you instantly",
    ],
    featured: false,
  },
  {
    badge: "Monthly",
    name: "Ongoing Monthly Management",
    tagline: "The full system, managed for you, so your pipeline never goes stale.",
    feats: [
      "Everything in the setup build",
      "Fresh creative rotated in every month",
      "Automated SMS + Messenger follow-up & CRM",
      "Prospecting + retargeting, continuously optimized",
      "Monthly reporting on what's actually working",
    ],
    featured: true,
  },
];

export const Packages = () => (
  <section className="relative z-10 bg-ink-900 py-24 sm:py-32" data-testid="packages-section">
    <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16">
      <Reveal><Eyebrow>Two ways to work together</Eyebrow></Reveal>
      <Reveal delay={80}>
        <h2 className="mt-5 font-display text-3xl sm:text-4xl lg:text-5xl text-cream leading-tight max-w-3xl">
          A one-time setup, or <span className="text-gold">ongoing monthly</span> help.
        </h2>
      </Reveal>
      <Reveal delay={120}>
        <p className="mt-6 text-parch max-w-2xl leading-relaxed">
          Get the whole system built once and run it yourself, or have us manage it month to month. Either way it's fully done-for-you, and your ad spend goes <strong className="text-cream">directly to Meta</strong>, the account, the data, and the results are always yours.
        </p>
      </Reveal>

      <div className="mt-16 grid md:grid-cols-2 gap-6 max-w-4xl">
        {OPTIONS.map((o, i) => (
          <Reveal key={o.name} delay={i * 100}>
            <div className={`relative flex flex-col h-full border ${o.featured ? "bg-ink-800 border-gold/50 shadow-[0_0_50px_rgba(201,146,58,0.15)]" : "bg-ink-800 border-ink-line"}`}>
              <span className="absolute top-0 inset-x-0 h-[3px] bg-gold" />
              <div className="p-8 border-b border-ink-line">
                <span className={`label inline-block text-[10px] px-3 py-1 mb-4 ${o.featured ? "bg-gold/20 text-gold" : "bg-ink-700 text-parch"}`}>{o.badge}</span>
                <h3 className="font-display text-2xl text-cream leading-tight">{o.name}</h3>
                <p className="mt-3 text-parch leading-relaxed">{o.tagline}</p>
              </div>
              <div className="p-8 flex-1">
                <ul className="space-y-3">
                  {o.feats.map((txt, j) => (
                    <li key={j} className="flex gap-3 leading-snug">
                      <Check size={18} className="text-gold shrink-0 mt-0.5" />
                      <span className="text-cream/80">{txt}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="p-8 pt-0">
                <a
                  href={CALENDAR_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`package-cta-${i}`}
                  className={`label block text-center text-xs px-6 py-4 rounded-[2px] transition-all duration-300 ${o.featured ? "bg-gold text-ink-900 hover:bg-gold-light" : "border border-gold/60 text-gold hover:bg-gold hover:text-ink-900"}`}
                >
                  Book a Strategy Call
                </a>
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={120}>
        <p className="mt-10 text-sm italic text-parch">
          Minimum $1,500/mo ad spend, paid directly to Meta. Not sure which fits? Book a free call and we'll map the right path for your market.
        </p>
      </Reveal>
    </div>
  </section>
);

export default Packages;
